const update_status = {
	forced_reset: "Force Reset",
	forced_shutdown: "Force Shutdown",
	reboot: "Reboot",
	shutdown: "Shutdown",
	start: "Start",
};

export default update_status;
